<template>
    <dialog-base
        fullscreen
        @close="handleClose"
        :showDialog="showDialog"
    >
        <dialog-body>
            <div
                class="d-flex justify-center align-center"
                style="background-color: darkgrey; height: 100vh;"
            >
                <dialog-button
                    class="fullscreen-preview-close-button"
                    color="secondary"
                    @click="handleClose"
                >
                    <i :class="`actionbar-icon mr-1 mt-1 fa-light fa-close fa-fw fa-lg`" />
                    {{ tClose }}
                </dialog-button>
                <iframe v-if="showDialog"
                    :src="url"
                    :style="iframeStyles"
                    sandbox="allow-forms allow-same-origin allow-scripts"
                    style="border: 0; transform-origin: top left;"
                />
            </div>
        </dialog-body>
    </dialog-base>
</template>

<script>
    import DialogBody from "../../dialog/components/dialog-body.vue";
    import DialogBase from "../../dialog/components/dialog-base.vue";
    import TextField from "../../common/text-field.vue";
    import DialogHeader from "../../dialog/components/dialog-header.vue";
    import DialogButton from "../../dialog/components/dialog-button.vue";

    export default {
        components: {
            DialogButton,
            DialogHeader, TextField, DialogBase, DialogBody
        },
        props: {
            url: String,
            aspect: String,
            resolution: String
        },
        data: function() {
            return {
                showDialog: false,

                calculatedWidth: undefined,
                calculatedHeight: undefined,
            }
        },
        computed: {
            tClose() { return Lang.langGet('Close Preview'); },
            iframeStyles() {
                return {
                    height: `${this.calculatedHeight}px`,
                    width: `${this.calculatedWidth}px`,
                }
            }
        },
        methods: {
            handleClose() {
                this.showDialog = false;
            },
            handleShow() {
                this.showDialog = true;
            },
            parseResolution(resolution) {
                if (!resolution) return [0, 0];

                const [widthStr, heightStr] = resolution.split('x');
                return [+(widthStr), +(heightStr)];
            },
            updateResolution(resolutionStr = this.resolution) {
                const [width, height] = this.parseResolution(resolutionStr);

                const tooWide = window.innerWidth < width;
                const tooHigh = window.innerHeight < height;
                if (!tooWide && !tooHigh) {
                    //enough space to show the original resolution
                    this.calculatedWidth = width;
                    this.calculatedHeight = height;
                    return;
                }

                // find the direction in which it overflows further and scale according to that one
                const diffWidthRatio = tooWide ? (width / window.innerWidth) : 1;
                const diffHeightRatio = tooHigh ? (height / window.innerHeight) : 1;

                // console.log('Diff Width Ratio', diffWidthRatio);
                // console.log('Diff Height Ratio', diffHeightRatio);

                const scaleToHeight = (diffHeightRatio >= diffWidthRatio);

                if (scaleToHeight) {
                    this.calculatedHeight = window.innerHeight;
                    this.calculatedWidth = width * this.calculatedHeight / height;
                } else {
                    this.calculatedWidth = window.innerWidth;
                    this.calculatedHeight = height * this.calculatedWidth / width;
                }
            }
        },
        mounted() {
            EaseEventBus.listen('showContentPreview', () => {
                this.handleShow();
            });
        },
        watch: {
            resolution: {
                immediate: true,
                handler(resolutionStr) {
                    this.updateResolution(resolutionStr);
                }
            },
            url: {
                immediate: true,
                handler() {
                    this.updateResolution();
                }
            }
        }
    }
</script>

<style scoped>
    .fullscreen-preview-close-button {
        position: absolute;
        top: 10px;
        right: 10px;
    }
</style>
